import {CardContent, Divider} from '@mui/material'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid'
import {MOpportunityEntityDetail} from 'app/modules/discovery/core/_models'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import OpportunitySearchResultCard from './cards/OpportunitySearchResultCard'
import EmptyStateCard from './emptyStates/emptyFolder'
import PaginationHeader from './pagination/PaginationHeader'
import useScrollPosition from './scroll/getScrollPosition'

interface Props {
  results?: MOpportunityEntityDetail[]
  loading: boolean
  page: number
  handlePagination: (e: React.ChangeEvent<unknown>, v: number) => void
  itemsPP: number
  totalCount: number
  scrollPosition?: number
  setScrollPosition?: (n: number) => void
  search: string
  prev?: boolean
  next?: boolean
}

export default function OpportunitySearchResult({
  results,
  loading,
  page,
  handlePagination,
  itemsPP,
  totalCount,
  search,
  prev,
  next,
}: Props) {
  const currScrollPosition = useScrollPosition()

  return (
    <Box sx={{flex: '1 1 auto', flexDirection: 'column', p: 3}}>
      <Card elevation={0}>
        <CardHeader
          title={
            <PaginationHeader
              prev={prev}
              next={next}
              results={results}
              loading={loading}
              itemsPP={itemsPP}
              page={page}
              handlePagination={handlePagination}
              totalCount={totalCount}
            />
          }
        ></CardHeader>
        <CardContent>
          {!results && loading ? (
            <Grid item xs={12}>
              <Skeleton
                height={70}
                count={10}
                wrapper={({children}) => {
                  return <div style={{marginBottom: '10px'}}>{children}</div>
                }}
              />
            </Grid>
          ) : (
            results?.map((opp, index) => {
              return (
                <Box key={index}>
                  <OpportunitySearchResultCard
                    opportunity={opp}
                    scrollPosition={currScrollPosition ?? undefined}
                    search={search ?? undefined}
                    fromDir={true}
                    page={page}
                  />
                  <Divider />
                </Box>
              )
            })
          )}
          {results && results.length > 15 && (
            <PaginationHeader
              prev={prev}
              next={next}
              results={results}
              loading={loading}
              itemsPP={itemsPP}
              page={page}
              handlePagination={handlePagination}
              totalCount={totalCount}
            />
          )}
          {results && results.length === 0 && !loading && (
            <EmptyStateCard
              title={'No opportunities found'}
              p={3}
              m={3}
              img={'wind'}
              size={'20%'}
            />
          )}
        </CardContent>
      </Card>
    </Box>
  )
}
